const AVAILABLE_TIPS = [
  'Pensez à vous tenir bien droit, en gardant les épaules basses, détendues.',
  'Soyez attentif à la position de vos mains, elles doivent rester juste au-dessus du niveau du clavier.',
  'Faites attention à garder les poignets détendus, surtout lorsque la difficulté augmente.',
  'Il faut avoir la sensation de jouer avec le métronome et non de le viser.',
  'Quand vous jouez les mains ensemble vous devez les sentir jouant ensemble sur le même tempo',
  'Faites attention à ce que votre assise soit bien réglée en hauteur. Il faut que vous vous teniez droit et que vous relâchiez les épaules ; les coudes doivent être à la hauteur ou un peu au-dessus de la hauteur des touches du clavier.',
  'Parfois, il vaut mieux s’arrêter quelques minutes. Après une petite pause (ou une bonne nuit de sommeil), les difficultés ont tendance à disparaitre !',
];

export function getRandomTip(optional = false) {
  if (optional && Math.random() < 0.5) {
    return ''
  }
  return AVAILABLE_TIPS[Math.floor(Math.random() * (Math.floor(AVAILABLE_TIPS.length) + 1))]
}

const CONFIRMATIONS_TIPS = [
  'Pensez à bien utiliser les bons doigtés !',
  'Écoutez vous attentivement pour être sûr de jouer les bonnes notes !',
];

export function getRandomConfirmationTip() {
  return CONFIRMATIONS_TIPS[Math.floor(Math.random() * (Math.floor(CONFIRMATIONS_TIPS.length) + 1))]
}
